/**
## /location

@module /location
*/

import create from './create.mjs';

import decorate from './decorate.mjs';

import { get, getInfoj } from './get.mjs';

import nnearest from './nnearest.mjs';

export default {
  create,
  decorate,
  get,
  getInfoj,
  nnearest,
};
